"use client";

import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import { useAuthStore } from "@/stores/auth";
import { api } from "@/lib/api";

export function AuthGate({ children }: { children: React.ReactNode }) {
  const router = useRouter();
  const { token, user, setAuth, clearAuth } = useAuthStore();
  const [hydrated, setHydrated] = useState(false);
  const [verified, setVerified] = useState(false);

  useEffect(() => {
    setHydrated(true);
  }, []);

  useEffect(() => {
    if (!hydrated) return;
    if (!token) {
      router.replace("/login");
      return;
    }
    api.auth
      .me(token)
      .then((u) => {
        setAuth(token, u);
        setVerified(true);
      })
      .catch(() => {
        clearAuth();
        router.replace("/login");
      });
  }, [hydrated, token, setAuth, clearAuth, router]);

  if (hydrated && verified && token && user) {
    return <>{children}</>;
  }

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-primary border-t-transparent" />
    </div>
  );
}
